import { spacing, ThemeUICSSObject } from '@apia/theme';

const confirm: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(6),
  height: '100%',
  width: '100%',
  overflow: 'auto',

  '.confirm__content': {
    overflow: 'auto',
    flexBasis: '100%',
    wordBreak: 'break-word',
    display: 'flex',
    flexDirection: 'column',
  },

  '.confirm__buttonBar': {
    display: 'flex',
    justifyContent: 'space-between',
    flexBasis: '40px',
    flexGrow: 0,
    flexShrink: 0,

    '.confirm__defaultButtons': {
      display: 'flex',
      gap: spacing(3),
    },
    '.confirm__customButtons': {
      width: 'auto',
    },
  },
};

export default confirm;
